export const Waves = () => {
  return (
    <svg
      width="907"
      height="3433"
      viewBox="0 0 907 3433"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className=""
    >
      <path
        d="M820.489 1469.51C812.905 1311.05 949.154 1217.65 892.059 1069.65C846.265 950.943 779.473 1069.51 658.973 842.011C538.473 614.511 504.473 612.511 476.473 602.511C448.473 592.511 286.321 550.726 211.799 396.679C137.276 242.633 122.825 179.828 33.9734 102.564C-54.878 25.3002 -210.088 0.237793 -210.088 0.237793L-821.899 453.207L-15.0107 3482.51C-15.0107 3482.51 435.721 3511.03 629.989 3341.5C760.628 3227.5 816.85 3110 800 2925.5C787.056 2783.77 757.011 2766 670.5 2635C626.1 2567.77 523.011 2405 560.5 2303C621.486 2137.07 673.341 2305.49 774.489 2160.51C841.793 2064.03 892.059 1947.5 892.059 1837.5C892.059 1604.61 831.624 1702.13 820.489 1469.51Z"
        fill="#49A6AB"
      />
      <path
        d="M727.5 1914C771.216 1859.78 827.084 1786.26 816 1717.5C785.531 1528.49 713.924 1568.26 718.5 1413C722.278 1284.83 782 1162 718.5 1082C655 1002 665.708 1064.39 610.604 915.693C555.5 767 511.37 722.05 488.725 703.206C466.079 684.362 303.095 676.613 226.514 539.948C149.932 403.283 134.049 345.701 46.0816 283.177C-41.8861 220.653 -192.105 215.158 -192.105 215.158L-766.928 714.228L-97.0319 3521.01C-97.0319 3521.01 326.693 3441 506.488 3257.01C618.245 3142.65 719.801 3065.38 716.48 2905.51C713.116 2743.62 627.5 2747 576.5 2584C523.305 2413.98 477.567 2468.51 462.5 2291C446.5 2102.5 672.338 2243.77 672.469 2080.01C672.535 1996.89 675.324 1978.71 727.5 1914Z"
        fill="#498EAB"
      />
      <path
        d="M44.4742 56.9075C45.2884 71.797 58.0188 83.2072 72.9082 82.393C87.7976 81.5787 99.2078 68.8484 98.3936 53.9589C97.5794 39.0695 84.849 27.6593 69.9596 28.4735C55.0702 29.2877 43.66 42.0181 44.4742 56.9075Z"
        fill="#49A6AB"
      />
      <path
        d="M101.901 112.277C102.399 121.376 110.178 128.349 119.278 127.851C128.377 127.353 135.35 119.574 134.852 110.475C134.354 101.376 126.575 94.4026 117.476 94.9002C108.377 95.3978 101.404 103.177 101.901 112.277Z"
        fill="#49A6AB"
      />
    </svg>
  );
};
